import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/debit.svg'
import _imports_1 from '@/assets/images/board-1.png'
import _imports_2 from '@/assets/images/virtual.svg'


const _hoisted_1 = { class: "card border-0 rounded-3 bg-white mb-4" }
const _hoisted_2 = { class: "card-body p-4 pb-0" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-6 mb-4" }
const _hoisted_5 = { class: "col-sm-6 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Card"),
        _createElementVNode("button", {
          class: "btn btn-outline-primary hover-bg fs-14 fw-medium",
          "data-bs-toggle": "modal",
          "data-bs-target": "#exampleModal"
        }, [
          _createElementVNode("i", { class: "ri-add-line me-1" }),
          _createElementVNode("span", null, "Add Card")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "bg-img p-4 rounded-3",
            style: _normalizeStyle({
              backgroundImage: `url(${_ctx.image})`,
            })
          }, _cache[0] || (_cache[0] = [
            _createStaticVNode("<div class=\"d-flex align-content-center justify-content-between mb-4\"><span class=\"text-white fs-12 fw-medium\">Debit Card</span><img src=\"" + _imports_0 + "\" alt=\"debit\"></div><img class=\"mb-4\" src=\"" + _imports_1 + "\" alt=\"board\"><h3 class=\"fw-semibold text-white mb-5 pb-md-4 d-flex gap-3\"><span>5322</span><span>0520</span><span>0744</span><span>1794</span></h3><div class=\"d-flex align-content-center justify-content-between\"><span class=\"text-white\">David Farrior</span><span class=\"text-white fs-12 fw-medium\">EXP : 12/30</span></div>", 4)
          ]), 4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "bg-img p-4 rounded-3",
            style: _normalizeStyle({
              backgroundImage: `url(${_ctx.image2})`,
            })
          }, _cache[1] || (_cache[1] = [
            _createStaticVNode("<div class=\"d-flex align-content-center justify-content-between mb-4\"><span class=\"text-white fs-12 fw-medium\">Debit Card</span><img src=\"" + _imports_2 + "\" alt=\"debit\"></div><img class=\"mb-4\" src=\"" + _imports_1 + "\" alt=\"board\"><h3 class=\"fw-semibold text-white mb-5 pb-md-4 d-flex gap-3\"><span>....</span><span>....</span><span>....</span><span>1794</span></h3><div class=\"d-flex align-content-center justify-content-between\"><span class=\"text-white\">David Farrior</span><span class=\"text-white fs-12 fw-medium\">EXP : 12/30</span></div>", 4)
          ]), 4)
        ])
      ])
    ])
  ]))
}